import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import ScheduleGradeOffScheduleLineTab from './ScheduleGradeOffScheduleLineTab';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class ScheduleGradeOffScheduleTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      staffs_available: [],
      schedule: {},
    };

    this.addFerias = this.addFerias.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.staffs_available) && typeof newProps.schedule.id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        staffs_available: newProps.staffs_available,
        schedule: newProps.schedule,
        loaded: 1,
      });
    }
  }

  addFerias (cell, row) {   
    return  <ScheduleGradeOffScheduleLineTab schedule={this.state.schedule} schedule_id={this.state.schedule.id} schedule_grade_id={this.props.schedule_grade_id} updateData={this.props.updateData} updated={this.state.updated} handleAlert={this.props.handleAlert} staff={row} />;
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Colaboradores não escalados neste mês</h3>
  <hr/>
  <BootstrapTable data={self.state.staffs_available} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há colaboradores fora de escala'}} search={true} multiColumnSearch={true} searchPlaceholder='Procurar'>

    <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default ScheduleGradeOffScheduleTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeOffScheduleTab.js